export const getPromotionRoutePath = (screenId: string, lang: string, defaultLanguage: string): string => {
    const screenPath = screenId.replace(/^\//, '');
    const langPrefix = lang === defaultLanguage ? '' : lang;
    return langPrefix ? `/${langPrefix}/${screenPath}` : `/${screenPath}`;
};

export const getPromotionCTAUrl = (item: any, url: any, user: any) => {
    if (item) {
        if (item && item.promoType && item.promoType === 'SEASON') {
            return url.route('play', {
                id: btoa(item.Id),
                guid: btoa(item?.seriesId?.split('/')?.pop()),
                season: item.seasonNumber,
            });
        } else if (item && item.promoType && item.promoType === 'EPISODE') {
            return url.route('play', {
                id: btoa(item.Id),
                guid: btoa(item.guid),
                season: item.tvSeasonNumber ? item.tvSeasonNumber : item.seasonNumber,
            });
        } else if ((item && item.promoType && item.promoType === 'SUBSCRIPTION') || item.promoType === 'TIER') {
            return user.getUserProfileUrl();
        } else if (item && item.promoType && item.promoType === 'REWIND') {
            return url.route('livetv', {
                id: btoa(item.Id),
                stationId: btoa(item.stationId),
                listingId: item.listingId ? btoa(item.listingId) : '',
            });
        } else if (item && item.promoType && item.promoType === 'CHANNEL') {
            return url.route('livetv', { channelId: btoa(item.channelId) });
        } else {
            return null;
        }
    }
};
